import { useMemo } from 'react';
import {
  GeometryType,
  useGetLayerQuery,
  useGetOrganizationInsightsQuery,
} from 'uf-api-rtk/store/Api';

const useAvailableInsights = (
  layerKey: string,
  layerNamespace: string,
  layerType: string,
  layerGeometry: GeometryType,
) => {
  const { data: layerMetadata } = useGetLayerQuery({
    key: layerKey,
    namespace: layerNamespace,
    layerType,
  });

  const {
    currentData: insights,
    isFetching,
    isLoading,
    isError,
    isSuccess,
    error,
  } = useGetOrganizationInsightsQuery(
    { key: layerNamespace },
    { skip: !layerNamespace },
  );
  // Create an array of available insights based on the layer's columns
  const allowedInsightKeys = useMemo(() => {
    const allowedKeys = new Set<number>();
    const layerColumns = new Set(layerMetadata?.columns?.map(({ key }) => key));
    if (layerGeometry) {
      insights?.forEach(insight => {
        if (
          insight.input_geo_types?.includes(
            layerGeometry.simple_geometry_type,
          ) &&
          !insight.required_columns?.some(
            column => !layerColumns.has(column.key),
          ) &&
          !(insight.id === 'existing_conditions' && layerType === 'analysis')
        ) {
          allowedKeys.add(insight.key);
        }
      });
    }
    return allowedKeys;
  }, [layerMetadata?.columns, layerGeometry, insights, layerType]);
  return {
    allowedInsightKeys,
    insights,
    isFetching,
    isLoading,
    isError,
    isSuccess,
    error,
  };
};

export default useAvailableInsights;
